<template>
  <div class="home">
    <ChangePasswordPage />
  </div>
</template>

<script>
import ChangePasswordPage from '../components/elements/pages/ChangePasswordPage.vue'
export default {
  name: 'ChangePassword',
  metaInfo: {
    title: 'Change Password Page'
  },
  components: {
    ChangePasswordPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
